import { useState, useCallback } from 'react';

interface ChartImages {
  [chartName: string]: string;
}

export const useChartCapture = () => {
  const [chartImages, setChartImages] = useState<ChartImages>({});

  const handleChartRendered = useCallback((chartName: string, imageDataUrl: string) => {
    setChartImages(prev => ({
      ...prev,
      [chartName]: imageDataUrl
    }));
  }, []);

  const resetChartImages = useCallback(() => {
    setChartImages({});
  }, []);

  return {
    chartImages,
    handleChartRendered,
    resetChartImages
  };
}; 